import { CheckCheck } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheckAll = mkIcon(CheckCheck);